import React from 'react';
import classNames from 'classnames';
import styles from './role-badge.module.scss';
export const RoleBadge = ({ className, label, }) => {
    return (React.createElement("div", { className: classNames(styles.root, className) },
        React.createElement("div", { className: styles.label }, label)));
};
//# sourceMappingURL=role-badge.js.map